/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cognito_identity_pool_id": "eu-north-1:ae018493-95d0-401d-8ca1-1c0b48c34039",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_YSCUTk0nT",
    "aws_user_pools_web_client_id": "4oe2cm9ud03jh0fhf9ik7gugp2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "verkstadernaadmin-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-north-1",
    "aws_content_delivery_url": "https://dfb63tveflzcx.cloudfront.net"
};


export default awsmobile;
